import React from 'react'
import styled from 'styled-components'
import Form from 'react-formal'
import { Link } from 'gatsby'
import * as yup from 'yup'
import Moment from 'moment'
import momentLocalizer from 'react-widgets-moment'
import permissions from '../../../../lib/permission/schema'
import { Flex, Box } from 'rebass'
import {
  Widget,
  Checkbox,
  Label,
  CenteredContentBox,
  Message,
  SubmitButton,
  Input,
  Fieldset,
  StripeCardElement
} from '.'
import { ModalSection } from '../../ContentModalSection/components/ModalSectionStyled'
import { trackEvent } from '../../../../lib/tracker'
import PermissionControls from './PermissionControls'
import LoadingSpinnerComponent from '../../LoadingSpinner'

Moment.locale('en-gb')
momentLocalizer()

const LoadingSpinner = styled(LoadingSpinnerComponent)`
  margin: auto;
`
const modelSchema = yup.object({
  email: yup
    .string()
    .default('')
    .required('Please enter an email address')
    .email('Please check your email address is correct')
    .max(255, 'Your email is over 255 characters'),
  firstName: yup
    .string()
    .default('')
    .required('Please enter your first name')
    .max(75, 'Your name is over 75 characters'),
  lastName: yup
    .string()
    .default('')
    .required('Please enter your last name')
    .max(75, 'Your last name is over 75 characters'),
  postcode: yup
    .string()
    .matches(/^[A-Z]{1,2}[0-9]{1,2}[A-Z]? ?[0-9][A-Z]{2}$/i, 'Invalid postcode')
    .required('Please enter your postcode'),
  phone: yup
    .string()
    .required('Please enter a phone number')
    .min(11, 'Please check your number')
    .max(16, 'Your number is too long'),
  permissions: permissions(['email', 'sms', 'phone']),
  termsAndConditions: yup
    .bool()
    .test(
      'terms-agreed',
      'You must agree to the terms and conditions',
      (v) => !!v
    )
})

Form.addInputTypes(require('react-formal-inputs'))

const ReserveForm = ({ success, error, onSubmit, submitting }) => {
  if (success) {
    trackEvent('Reserve', 'Form', 'Thanks')
    return (
      <ModalSection width={'100%'} py={20} px={'7%'}>
        <h2>Reserved for you. Thanks!</h2>
        <p>
          Thank you for your vehicle reservation, you will shortly receive an
          email confirmation and a Sales Manager will be in touch.
        </p>
      </ModalSection>
    )
  }
  return (
    <ModalSection width={'100%'} py={20} px={'7%'}>
      <Form
        schema={modelSchema}
        onSubmit={onSubmit}
        className="f24form"
        data-f24name="reserve-form"
      >
        {error && (
          <div>
            <h1>Sorry, there has been a problem.</h1>
            <p>{error.message}</p>
          </div>
        )}
        <Fieldset>
          <Flex flexWrap="wrap" width={'100%'} py={[10]}>
            <Box width={[12 / 12, null, 5 / 12]} mr={[0, null, '12%']} mb={10}>
              <Label>First name*</Label>
              <Input
                placeholder="Enter first name"
                name="firstName"
                aria-label="You are required enter your first name"
              />
              <Message for="firstName" />
            </Box>
            <Box width={[12 / 12, null, 5 / 12]} mb={10}>
              <Label>Last name*</Label>
              <Input
                placeholder="Enter last name"
                name="lastName"
                aria-label="You are required enter your last name"
              />
              <Message for="lastName" />
            </Box>
            <Box width={[12 / 12, null, 5 / 12]} mr={[0, null, '12%']} mb={10}>
              <Label>Phone number*</Label>
              <Input
                placeholder="Enter phone number"
                name="phone"
                aria-label="You are required enter your phone number"
              />
              <Message for="phone" />
            </Box>
            <Box width={[12 / 12, null, 5 / 12]} mb={10}>
              <Label>Email address*</Label>
              <Input
                placeholder="Enter email address"
                name="email"
                aria-label="Enter your email, this is optional"
              />
              <Message for="email" />
            </Box>
            <Box width={[12 / 12, null, 5 / 12]} mr={[0, null, '12%']} mb={10}>
              <Label>Postcode*</Label>
              <Widget>
                <Input
                  placeholder="Enter postcode"
                  name="postcode"
                  aria-label="You are required to enter your postcode"
                />
                <Message for="postcode" />
              </Widget>
            </Box>
            <Box width={[12 / 12, null, 10 / 12 + 0.12]} mb={10}>
              <Label>Card details*</Label>
              <StripeCardElement hidePostalCode />
            </Box>
            <PermissionControls email sms phone />
            <Box width={12 / 12} mb={10}>
              <Label>
                <Checkbox
                  name="termsAndConditions"
                  aria-label="You are required to agree to our terms and conditions"
                />
                I agree to Citygate’s{' '}
                <Link to="/legal">terms and conditions</Link>
              </Label>
              <Message for="termsAndConditions" />
            </Box>
            <CenteredContentBox width={12 / 12} mt={35}>
              {submitting && <LoadingSpinner />}
              {!submitting && (
                <SubmitButton type="submit" aria-label="Reserve">
                  Reserve
                </SubmitButton>
              )}
            </CenteredContentBox>
          </Flex>
        </Fieldset>
      </Form>
    </ModalSection>
  )
}
export default ReserveForm
